import {AUTH_TYPE, AWSAppSyncClient} from "aws-appsync";
import {checkCurrentUser} from "@/services/authentication";
import config from '../../config/config'
import router from '../router'
import {GraphQLError} from "graphql";
import store from '../store'

const gqlClient = new AWSAppSyncClient({
    url: config.graphqlUrl,
    region: config.region,
    auth: {
        type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
        jwtToken: async () => {
            const session = await checkCurrentUser()
            return session.getIdToken().getJwtToken()
        }
    }
}, {
    defaultOptions: {
        query: {
            fetchPolicy: 'no-cache'
        }
    }
})

export async function gQuery<T, TVariables = never>(query: any, variables?: TVariables): Promise<ApolloQueryResult<T>> {
    try {
        return await gqlClient.query<T, TVariables>({query, variables})
    } catch (error) {
        errorCatch(error)
        throw error
    }
}

export async function gMutate<T, TVariables>(mutation: any, variables?: TVariables) {
    try {
        return await gqlClient.mutate<T, TVariables>({mutation, variables})
    } catch (error) {
        errorCatch(error)
        throw error
    }
}

type HttpError = { code: number }
type GQLError = { graphQLErrors: GraphQLError[] }

function errorCatch(error: Error | HttpError | GQLError) {
    console.log(error)
    if (Object.prototype.hasOwnProperty.call(error, 'code') && (error as HttpError).code === 440) {
        router.push({name: 'login'})
    } else if (Object.prototype.hasOwnProperty.call(error, 'graphQLErrors')) {
        store.commit('setErrorMessage', (error as GQLError).graphQLErrors[0].message)
    } else if (Object.prototype.hasOwnProperty.call(error, 'message')) {
        store.commit('setErrorMessage', (error as Error).message)
    }
    throw error
}

export type ApolloQueryResult<T> = {
    data: T;
    errors?: GraphQLError[];
    loading: boolean;
    stale: boolean;
};
